import notice from "../../utils/notice";
import { WEEKLY_REPORTS } from "../helpers/routes";
import { getMultipartParams, handleResponse } from "../helpers/validate";

export const getWeeklyReport = async (params = {}) => {
  const query = new URLSearchParams({
    view_type: params.view_type || "team",
    page: (params.page || 1).toString(),
    per_page: (params.per_page || 25).toString(),
    ...(params.week_start && { week_start: params.week_start }),
    ...(params.week_end && { week_end: params.week_end }),
    ...(params.partner_id && { partner_id: params.partner_id }),
  });

  return fetch(`${WEEKLY_REPORTS}?${query}`, getMultipartParams("GET"))
    .then((res) => handleResponse(res))
    .catch((e) => {
      notice("Error loading weekly report");
      throw e;
    });
};

export const exportWeeklyReportCSV = async (params = {}) => {
  const query = new URLSearchParams({
    view_type: params.view_type || "team",
    ...(params.week_start && { week_start: params.week_start }),
    ...(params.week_end && { week_end: params.week_end }),
    ...(params.partner_id && { partner_id: params.partner_id }),
  });

  return fetch(`${WEEKLY_REPORTS}/export?${query}`, getMultipartParams("GET"))
    .then(async (res) => {
      if (!res.ok) throw new Error("Export failed");
      const blob = await res.blob();
      if (!blob.size) throw new Error("Empty export response");
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `weekly_report_${params.view_type || "team"}_${params.week_start || "all"}.csv`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    })
    .catch((e) => {
      notice("Error exporting CSV");
      throw e;
    });
};
